import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/enhance";
const TITLE = "Enhance Your Stay — Add-Ons, Packages & Guided Tours | Backland";
const DESC =
  "Curated stay enhancements at Backland: in-suite amenities, romance and family packages, guided tours, and on-property experiences to elevate every moment.";
const OG_IMAGE =
  "/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/enhance-hero-couple.jpg";

export const Route = createFileRoute("/enhance")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Backland Stay Enhancements",
          serviceType: "Hospitality add-ons and guided experiences",
          url: URL,
          description: DESC,
          provider: {
            "@type": "LodgingBusiness",
            name: "Backland",
            url: "https://www.travelbackland.com",
          },
        }),
      },
    ],
  }),
  component: EnhanceRoute,
});

function EnhanceRoute() {
  return <StoryExperience initialCategorySlug="enhance" />;
}
